if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        this.intiateCartExtra();
        this.varAddBundle();
        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            console.log(response)
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.intiateCartExtra();
            this.varAddBundle();
            
            // if (this.form.dataset.refill == 'refill'){
            //   this.justAddedRefill();
            // }else if(this.form.dataset.cartmx == undefined){
            //   this.justAdded();
            // }
            // this.justAdded();
          });
      }

      justAdded(){
        const just_add = document.querySelector(".drawer__inner .just-added");
        var just_elm = document.querySelector('#CartDrawer-Item-1');
        var just_tb = document.querySelector('table.cart-items.just-added-tb tbody');
        just_tb.innerHTML = just_elm.innerHTML;
        just_elm.classList.add("none-imp");
        just_add.classList.add("flx-tb");
      }

      justAddedRefill(){
        setTimeout(() => {
          const just_add = document.querySelector(".drawer__inner .just-added");
          const cart_items = document.querySelectorAll(".drawer__cart-items-wrapper > .cart-items > tbody > .cart-item");
          const pro_qty = document.querySelectorAll(".cart-item-pro_qty");
          var just_tb = document.querySelector('table.cart-items.just-added-tb tbody');
          just_add.classList.add("flx-tb");
          just_add.classList.add("flx-tb-refill");
          var just_elm = document.querySelector('.cart-item-cart-0');
          just_elm.setAttribute('style', 'display:flex !important');

          if (pro_qty && pro_qty != undefined){
            cart_items.forEach((itm, idx, array) => {
              itm.setAttribute('style', 'display:none !important');
            });
            
            pro_qty.forEach((elem, idx, array) => {
              if (idx === array.length - 1){ 
                var inn = '';
                document.querySelectorAll(".bordered").forEach((qty) => {
                    var qty_val = parseInt(qty.querySelector("input").value);
                    var qty_txt = qty.querySelector("oo").innerHTML;
                    if(qty_val > 0){
                      inn += '<dd>' + qty_val + ' x ' + qty_txt + '</dd>';
                    }
                });
                
                elem.querySelector('.product-option').classList.add("opt-multi");
                elem.querySelector('.product-option').innerHTML = inn;

                just_tb.innerHTML = elem.innerHTML;
                elem.setAttribute('style', 'display:none !important');

                var tb_price = document.querySelector('.just-added .product-option.cart-item_price');
                var po = document.querySelector('po');

                fetch('/cart.js')
                  .then(response => response.text())
                  .then((responseText) => {
                    var data = JSON.parse(responseText);
                    console.log(data)
                    if (data.total_discount > 0){
                      var s = data.original_total_price / 100;
                      var fin = data.total_price / 100;

                      var dis_html = document.querySelector('.drawer__inner .just-added.flx-tb s.cart-item__old-price.product-option');
                      var final_html = document.querySelector('.drawer__inner .just-added.flx-tb strong.cart-item__final-price.product-option');


                      if (dis_html && dis_html != undefined){
                        dis_html.innerHTML = '€'+ s.toFixed(2) ;
                        final_html.innerHTML = '€'+  fin.toFixed(2);
                      }else{
                        tb_price.innerHTML = `<div class="cart-item__discounted-prices">
                              <span class="visually-hidden" data-wg-notranslate="">
                                Regular price
                              </span>
                              <s class="cart-item__old-price product-option">€${s.toFixed(2)}</s>
                              <span class="visually-hidden" data-wg-notranslate="">
                                Sale price
                              </span>
                              <strong class="cart-item__final-price product-option">
                                ${fin.toFixed(2)}
                              </strong>
                            </div>`
                      }

                      
                    }else if (tb_price && tb_price != undefined){
                      tb_price.innerHTML  = po.innerHTML;
                    }
    
                });

                
              }
            })
          }
        }, 500);
      }

      varAddBundle(){
        const variant_add = document.querySelectorAll(".var-pro-add");

        if (variant_add && variant_add != undefined){
          variant_add.forEach((variant) => {
            variant.addEventListener('click', function(e){
              e.preventDefault();
              var id = variant.dataset.var;        
              var elm_car = document.querySelector('[data-form-cart="'+id+'"]');
              elm_car.querySelector('button[type="submit"]').click();
            });
          });
        }
      }

      intiateCartExtra(){
        const extra_cart_check = document.querySelectorAll('.extra-bot');
        if (extra_cart_check && extra_cart_check != undefined){
          extra_cart_check.forEach((variant) => {
            variant.addEventListener('click', function(e){
              e.preventDefault();
              var id = variant.dataset.var;
              var for_att = variant.getAttribute('for');
              var ext_item = document.querySelector('.cart-item-extra[data-item="'+for_att+'"]');
              var quick_add_extra = document.querySelector('.quick-add-extra[data-item="'+for_att+'"]');
    
              var added_var = variant.classList.contains("added");
            
              if(added_var == false){
                quick_add_extra.querySelector('button').click();
                if(document.documentElement.clientWidth > 786){
                  ext_item.style.display = 'table-row';
                }else{
                  ext_item.style.display = 'grid';
                }
              }else{
                ext_item.querySelector('cart-remove-button a').click();
                ext_item.style.display = 'none';
              }
              document.querySelector('.main__cart-items').style.height = 'unset';
            });
          });
        }

        if (window.location.href.indexOf("/nl/") > -1) {
          const go = document.querySelector(".cart-drawer a.go_to_cart");
          if (go && go != undefined){
            go.setAttribute('href',"/nl/cart")
          }
        }

        
        
      }
    
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
